// extracted by mini-css-extract-plugin
module.exports =  {"container":"PcQwHdMPXt2Np7_TQmf9","animations":"AzSBSpUyShSW4vC4rqXq","canvas":"MRRrNW4m2oJYcMCOSyNx"};